/**
 * @generated SignedSource<<8d6596c6721dbf2c5bc3b8b1f1a1c79e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkDeleteSavedReportInput = {
  reportServiceIds?: ReadonlyArray<string | null> | null;
  savedReportIds?: ReadonlyArray<string | null> | null;
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type bulkDeleteSavedReportMutation$variables = {
  input: BulkDeleteSavedReportInput;
};
export type bulkDeleteSavedReportMutation$data = {
  readonly bulkDeleteSavedReport: {
    readonly deletedReportIds: ReadonlyArray<string | null> | null;
    readonly company: {
      readonly id: string;
    } | null;
  } | null;
};
export type bulkDeleteSavedReportMutation = {
  variables: bulkDeleteSavedReportMutation$variables;
  response: bulkDeleteSavedReportMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkDeleteSavedReportPayload",
    "kind": "LinkedField",
    "name": "bulkDeleteSavedReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedReportIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkDeleteSavedReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkDeleteSavedReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "67ef25a50d9c3c7bd38c01b02d6c107a",
    "id": null,
    "metadata": {},
    "name": "bulkDeleteSavedReportMutation",
    "operationKind": "mutation",
    "text": "mutation bulkDeleteSavedReportMutation(\n  $input: BulkDeleteSavedReportInput!\n) {\n  bulkDeleteSavedReport(input: $input) {\n    deletedReportIds\n    company {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d06e8325a70b4f10c251c6b798ec8ee";

export default node;
